// ArcaOS frontend API client — adds Bearer token + active org header.
const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/os`;

let _orgId = null;
export const setActiveOrg = (id) => { _orgId = id; };
export const getActiveOrg = () => _orgId;

export async function osFetch(path, { method = "GET", body, headers = {} } = {}) {
  const token = localStorage.getItem("arca_token");
  const h = { "Content-Type": "application/json", ...headers };
  if (token) h.Authorization = `Bearer ${token}`;
  if (_orgId) h["X-Org-Id"] = _orgId;
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers: h,
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    let detail = "Request failed";
    try { detail = (await res.json()).detail || detail; } catch { /* ignore */ }
    const err = new Error(typeof detail === "string" ? detail : JSON.stringify(detail));
    err.status = res.status;
    throw err;
  }
  if (res.status === 204) return null;
  return res.json();
}
